import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation, Trans } from "react-i18next";
import { LANDING } from "@/constants/testIds";

const IMG = "/storytelling.jpg";

export default function Storytelling() {
  const { t } = useTranslation();
  return (
    <section
      id="storia"
      data-testid={LANDING.storytelling}
      className="relative bg-[#fafaf7] py-24 md:py-36 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image column */}
          <div className="lg:col-span-6 order-2 lg:order-1 reveal">
            <div className="zoom-wrap aspect-[4/5] md:aspect-[3/4] w-full">
              <img
                src={IMG}
                alt="People of Europe"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="mt-5 flex items-center justify-between text-[#475569]">
              <span className="text-[11px] tracking-[0.28em] uppercase font-body">
                {t("storytelling.missionTag")}
              </span>
              <span className="text-[11px] tracking-[0.28em] uppercase font-body">
                EU · 2026
              </span>
            </div>
          </div>

          {/* Text column */}
          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="reveal delay-1">
              <span className="eyebrow">{t("storytelling.eyebrow")}</span>
              <h2
                data-testid={LANDING.storytellingHeadline}
                className="font-display text-4xl md:text-5xl lg:text-6xl text-[#1a365d] leading-[1.06] tracking-tight mt-5"
              >
                {t("storytelling.title1")} <br />
                <span className="italic">{t("storytelling.title2")}</span>
              </h2>
            </div>

            <div className="reveal delay-2 mt-8 max-w-xl space-y-5 text-[#475569] leading-[1.85] text-base md:text-[17px]">
              <p>
                <Trans
                  i18nKey="storytelling.paragraph1"
                  components={{ strong: <strong className="text-[#1a365d]" /> }}
                />
              </p>
              <p>{t("storytelling.paragraph2")}</p>

              {/* Stats row */}
              <div className="mt-12 grid grid-cols-3 gap-6 border-t border-[#e2e8f0] pt-8">
                <div>
                  <div className="font-display text-3xl md:text-4xl text-[#1a365d]">
                    27
                  </div>
                  <div className="mt-1 text-[10.5px] tracking-[0.28em] uppercase text-[#475569]">
                    {t("storytelling.statCountries")}
                  </div>
                </div>
                <div>
                  <div className="font-display text-3xl md:text-4xl text-[#1a365d]">
                    450M+
                  </div>
                  <div className="mt-1 text-[10.5px] tracking-[0.28em] uppercase text-[#475569]">
                    {t("storytelling.statCitizens")}
                  </div>
                </div>
                <div>
                  <div className="font-display text-3xl md:text-4xl text-[#1a365d]">
                    24
                  </div>
                  <div className="mt-1 text-[10.5px] tracking-[0.28em] uppercase text-[#475569]">
                    {t("storytelling.statLanguages")}
                  </div>
                </div>
              </div>

              <Link
                to="/mission"
                data-testid={LANDING.storytellingCta}
                className="btn-outline mt-12"
              >
                {t("storytelling.cta")}
                <ArrowRight size={14} strokeWidth={1.8} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
